import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { getTrialDaysRemaining, isActiveTrial } from '../utils/subscriptionAccess';

/**
 * Banner shown while the current org is on an active free trial.
 * CTA routes to /plans (Phase 2 plan picker).
 */
const TrialBanner = ({ orgDetails, isWhiteLabelApp }) => {
  const isWhiteLabelContext =
    isWhiteLabelApp || String(orgDetails?.whiteLabelId || '0') !== '0';
  if (isWhiteLabelContext || !isActiveTrial(orgDetails)) return null;

  const daysLeft = getTrialDaysRemaining(orgDetails);
  const daysLabel =
    daysLeft == null
      ? 'Your free trial is active'
      : daysLeft <= 0
        ? 'Your free trial ends today'
        : daysLeft === 1
          ? '1 day left in your free trial'
          : `${daysLeft} days left in your free trial`;

  return (
    <div
      className='flex flex-wrap items-center justify-between gap-3 border-b border-border bg-info-bg px-4 py-2 text-sm text-info'
      role='status'>
      <span className='font-medium text-foreground'>
        {daysLabel}. Full product access — choose a plan before your trial ends.
      </span>
      <Button asChild size='sm' variant='default'>
        <Link to='/plans'>Choose a plan</Link>
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  orgDetails: state.organisation?.details,
  isWhiteLabelApp: state?.whiteLabelAdmin?.whiteLabelId !== '0',
});

export default connect(mapStateToProps)(TrialBanner);
